import React from "react";
import "./Home.scss";
import Hero from "app/pages/Home/Hero/Hero";

class Home extends React.Component {
  render() {
    return <Hero />;
  }
}

export default Home;
